module.exports = __webpack_public_path__ + "img/group23-en.c9f689cb.png";